import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {media} from '~/shared/theme/media';

import {MyTenbisActionButtonConfig} from './types';
import ActionButton from './ActionButton';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  ${media.minLargeTablet`
    width: 386px;
  `}
`;

type ActionsSectionProps = {
  actions: MyTenbisActionButtonConfig[];
};

const ActionsSection = ({actions}: ActionsSectionProps) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      {actions.map((item, index) => (
        <ActionButton key={item.key} caption={t(item.caption)} withBorderTop={index > 0} onClick={item.onClick} />
      ))}
    </Root>
  );
};

export default memo(ActionsSection);
